import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/__authenticated/approvals/')({
	beforeLoad: () => {
		throw redirect({ to: '/approvals/required-attention', throw: true });
	},
});
